import {
  adsReadinessSnapshot,
  subscribeAdsReadiness,
} from '@redbrickmedia/duplex.user-identity'
import { consentCountry } from './consentGate'

export function adsMayRequest(): boolean {
  const { status } = adsReadinessSnapshot({ country: consentCountry() })
  return status === 'ready' || status === 'not-applicable'
}

export function withReadyAyManager(
  enqueue: (callback: () => void) => void,
  run: () => void
): () => void {
  let active = true
  let queued = false
  let unsubscribe = () => {}
  const queue = () => {
    if (!active || queued || !adsMayRequest()) return
    queued = true
    enqueue(() => {
      queued = false
      if (!active || !adsMayRequest()) return
      active = false
      unsubscribe()
      run()
    })
  }
  unsubscribe = subscribeAdsReadiness(queue, { country: consentCountry() })
  if (!active) unsubscribe()
  queue()
  return () => {
    active = false
    unsubscribe()
  }
}
